import React, { Component } from 'react';
import { Field } from 'redux-form';
import { intlShape, injectIntl } from 'react-intl';
import TextField from '../../../../shared-components/TextField/TextField';
import { isEmpty } from '../../../../shared-components/FormElement/FormElementUtils';
import { hasNoRestrictedInput } from '../StreetGroup/StreetGroup';

const LOCALE_PREFIX = 'US/pages/BillingAddressPage/BillingAddressForm';

//Copying current pattern matching textinput uses in CAPE
export const isValidCity = (msg) => (value) => {
    const pattern = /^([a-zA-Z0-9\s-]+)$/;

    if (pattern.test(value)){
        return;
    } else {
        return {
            msg,
            className: 'hasError'
        };
    }
};

export class City extends Component {
    static propTypes = {
        intl: intlShape.isRequired
    };

    render() {
        const { intl } = this.props;

        return (
            <Field
                id="city"
                name="city"
                autoComplete="disabled"
                autoCorrect="off"
                autoCapitalize="off"
                component={TextField}
                label={intl.formatMessage({id: `${LOCALE_PREFIX}.city-label`})}
                validate={[
                    isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.billinginfo-empty`})),
                    isValidCity(intl.formatMessage({id: `${LOCALE_PREFIX}.billinginfo-city-invalid`})),
                    hasNoRestrictedInput(intl.formatMessage({id: `${LOCALE_PREFIX}.billinginfo-restricted-alp2-invalid`}))
                ]}
            />
        );
    }
}

export default injectIntl(City);
